import { NgModule } from '@angular/core';
import { LOCATION_TOKEN } from '@new/common/location';
import { AdminRoutingModule } from './admin-routing.module';

@NgModule({
  imports: [AdminRoutingModule],
  providers: [
    {
      provide: LOCATION_TOKEN,
      useValue: window.location
    }
  ]
})
export class AdminModule {}
